import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import {
  InsuranceFlowStatus,
  insuranceFlowStatusOrder,
} from 'src/app/_enums/insurance-flow/insurance-flow-status.enum';
import { LeadStatus } from 'src/app/_enums/lead-status.enum';
import { ProposalService } from 'src/app/_services/proposal.service';
import { ActionModalComponent } from 'src/app/shared/components/action-modal/action-modal.component';
import { IconsModule } from 'src/app/shared/icons/icons.module';
import { StepperComponent } from 'src/app/shared/ui-kit/stepper/stepper.component';

import { TaskDetailsService } from '../../../../task-details.service';
import { BaseStepperAction } from '../base-action';

@Component({
  selector: 'app-cancel-lead-action',
  standalone: true,
  imports: [
    CommonModule,
    StepperComponent,
    NgbTooltipModule,
    IconsModule,
    ActionModalComponent,
  ],
  templateUrl: './cancel-lead.component.html',
})
export class CancelLeadStepperActionComponent extends BaseStepperAction {
  @ViewChild('cancelLeadModal') cancelLeadModal: ActionModalComponent;

  submitted = false;

  get enabled() {
    const status = this.state?.insuranceFlowData?.status;
    return (
      status !== InsuranceFlowStatus.LEAD_CANCELLED &&
      insuranceFlowStatusOrder[status] <
        insuranceFlowStatusOrder.PENDING_CONTRACT
    );
  }

  constructor(
    taskDetailsService: TaskDetailsService,
    private readonly proposalService: ProposalService,
    private readonly toastrService: ToastrService
  ) {
    super(taskDetailsService);
  }

  cancelLead() {
    const leadId = this.taskDetailsService.state.lead?.leadId;
    if (!this.submitted && leadId) {
      this.submitted = true;
      this.proposalService
        .updateLeadStatus({ leadId, status: LeadStatus.CANCELLED })
        .subscribe({
          next: (res) => {
            if (res?.error) {
              this.toastrService.error(
                $localize`Une erreur est survenue. Veuillez réessayer ultérieurement`
              );
            } else {
              this.toastrService.success(
                $localize`Demande annulée avec succès`
              );
              this.cancelLeadModal?.closeModal();
              this.taskDetailsService.refreshTaskDetails();
            }
            this.submitted = false;
          },
          error: () => {
            this.toastrService.error(
              $localize`Une erreur est survenue. Veuillez réessayer ultérieurement`
            );
            this.submitted = false;
          },
        });
    }
  }
}
